module.exports = __webpack_public_path__ + "img/d-down-nav-w.7946c522.svg";